import { Col, Form, Input, Row, Select } from "antd";
import { Button as BootstrapButton } from "react-bootstrap";
import { CustomDropdownSelect } from "../../../../components";
import { eBizTitleOptions, eLocation } from "../../../../constants/bizTitle";
import { RegExp } from "../../../../constants";

interface InsertEmployeeFormProps {
  onSubmit: (values: any) => void;
  employee: any;
  department: any[];
}

export const InsertEmployeeForm = (props: Partial<InsertEmployeeFormProps>) => {
  const { onSubmit = () => {}, employee, department } = props;
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    onSubmit({ ...(employee ?? {}), ...values });
  };

  return (
    <Form
      name="dynamic_form_nest_item"
      autoComplete="off"
      form={form}
      size="large"
      layout="vertical"
      onFinish={onFinish}
      initialValues={employee}
    >
      <Row gutter={[32, 0]}>
        <Col span={12}>
          <Form.Item
            required
            label="Mã nhân viên"
            name="eEmployeeId"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập mã nhân viên!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            required
            label="Phòng ban"
            name="eDepartmentCode"
            rules={[
              {
                required: true,
                message: "Vui lòng chọn trường này!",
              },
            ]}
          >
            <Select
              showSearch
              options={department}
              className="min-w-full"
              key="key"
              placeholder="Vui lòng chọn phòng ban"
            />
          </Form.Item>
          <Form.Item
            required
            label="Chức vụ"
            name="eBizTitleCode"
            rules={[
              {
                required: true,
                message: "Vui lòng chọn trường này!",
              },
            ]}
          >
            <CustomDropdownSelect
              options={eBizTitleOptions}
              className="min-w-full"
              addInputPlaceholder="Nhập chức vụ"
              addButtonText="+ Thêm chức vụ"
              key="key"
              placeholder="Vui lòng chọn chức vụ"
            />
          </Form.Item>
          <Form.Item label="SĐT" name="ePhone" rules={[
            {
              message: "Số điện thoại không hợp lệ",
              pattern: RegExp.vnPhoneNumber,
            }
          ]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            required
            label="Họ tên"
            name="Title"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập họ tên nhân viên!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Vị trí" name="eLocation">
            <Select options={eLocation} className="min-w-full" placeholder="Vui lòng chọn vị trí" />
          </Form.Item>
          <Form.Item
            required
            label="Email"
            name="eMail"
            rules={[
              {
                message: "E-mail phải kết thúc bằng @viags.vn!",
                pattern: RegExp.viagsEmail,
              },
              {
                required: true,
                message: "Vui lòng nhập E-mail!",
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <div className="flex-end">
        <BootstrapButton variant="success" type="submit">
          Xác nhận
        </BootstrapButton>
      </div>
    </Form>
  );
};
